import React from 'react'
import { Helmet } from 'react-helmet'
import Statistics from '../../Home/Statistics'
import AboutBanner from './AboutBanner'
import Leaders from './Leaders'
import Trail from './Trail'
import Why from './Why'

const About = () => {
  return (
    <div className='pt-[70px]'>

      <Helmet >
        <title>About Us</title>
      </Helmet>

      <div className='dark:bg-gray-900 transition-all duration-700 md:pb-10'>
        <AboutBanner />
      </div>
      <Trail />
      <div className='dark:bg-slate-800 bg-gray-50 transition-all duration-700 '>
        <Leaders />
      </div>
      <div className='dark:bg-gray-900 transition-all duration-700 md:pb-10'>
        <Why />
      </div>
      <div className='dark:bg-gray-800 bg-gray-50 transition-all duration-700'>
        <Statistics />
      </div>
    </div>
  )
}

export default About